export default (el, binding) => {
  if (binding.value && binding.value != binding.oldValue) {
    el.querySelector("input").focus();
  }
};
